export const GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS";
export const ON_TASK_SUBMITED_SUCCESS = "ON_TASK_SUBMITED_SUCCESS";
